import { TenantDetailsTable } from "modules/tenants/sections/plt/details/components/TenantDetailsTable";
import { TenantResourcesTable } from "modules/tenants/sections/plt/details/components/TenantResourcesTable";
import { EncryptTenantResourcesButton } from "modules/tenants/sections/plt/EncryptTenantResourcesButton";
import { TenantSectionProps } from "modules/tenants/sections/plt/types";

import { ScrollablePane, Stack, Text, useTheme } from "@bps/fluent-ui";
import { CopyableGuid } from "@components/CopyableText";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { ApplicationType } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Permissions } from "@libs/permissions/permissions.enum";

import { CommandRunnerContextProvider } from "../../../../_shared-context/command-runner-context/command-runner-context.provider";
import { ChangeIsInActiveButton } from "./components/ChangeIsInActiveButton";
import { ChangeIsTemporaryButton } from "./components/ChangeIsTemporaryButton";
import { CreateChildTenantDialog } from "./components/CreateChildTenantDialog";
import { TenantEditDetailsFormDialog } from "./components/TenantEditDetailsFormDialog";

const TenantDetailsBase = ({ tenant }: TenantSectionProps) => {
  const theme = useTheme();
  return (
    <Stack
      verticalFill
      styles={{ root: { padding: theme.spacing.s1 } }}
      tokens={{ childrenGap: theme.spacing.l2 }}
    >
      <Stack tokens={{ childrenGap: 16 }}>
        <SectionTitle>{tenant.name}</SectionTitle>
        {tenant?.isInactive && (
          <Text
            variant="xLarge"
            styles={{ root: { color: theme.semanticColors.errorText } }}
          >
            <b>Tenant is inactive</b>
          </Text>
        )}
        <CopyableGuid
          value={tenant.id}
          variant="small"
          color={theme.palette.themeSecondary}
        />
        <Stack horizontal tokens={{ childrenGap: theme.spacing.s1 }}>
          <TenantEditDetailsFormDialog tenant={tenant} />
          {tenant.application === ApplicationType.CAM && (
            <CreateChildTenantDialog tenant={tenant} />
          )}
        </Stack>
      </Stack>

      <Stack
        verticalFill
        styles={{ root: { position: "relative", width: "100%" } }}
      >
        <ScrollablePane>
          <Stack tokens={{ childrenGap: theme.spacing.l2 }}>
            <Stack grow>
              <TenantDetailsTable tenant={tenant} />
            </Stack>
            <Stack>
              <Text variant="xLarge">Resources</Text>
              <TenantResourcesTable tenant={tenant} />
            </Stack>
            <Stack horizontal tokens={{ childrenGap: theme.spacing.s1 }}>
              <CommandRunnerContextProvider>
                <EncryptTenantResourcesButton {...tenant} />
              </CommandRunnerContextProvider>
              <CommandRunnerContextProvider>
                <ChangeIsTemporaryButton {...tenant} />
              </CommandRunnerContextProvider>
              <CommandRunnerContextProvider>
                <ChangeIsInActiveButton {...tenant} />
              </CommandRunnerContextProvider>
            </Stack>
          </Stack>
        </ScrollablePane>
      </Stack>
    </Stack>
  );
};

export const TenantDetails = withPermissions(
  TenantDetailsBase,
  [
    Permissions.PltCatalogTenantRead,
    Permissions.PltCatalogTenantWrite,
    Permissions.PltCatalogOpsWrite
  ],
  "or"
);
